export const LINE_QUOTE_URL_MOBILE = "https://line.me/R/oaMessage/@kmcp.acc/?ขอใบเสนอราคา";
export const LINE_QUOTE_URL_WEB = "https://line.me/R/ti/p/@kmcp.acc";
// Backward compatibility for existing imports; defaults to mobile deep link.
export const LINE_QUOTE_URL = LINE_QUOTE_URL_MOBILE;
